export default __webpack_public_path__ + "bef6c93714971f5e8ea5b629eeff465d.mp3";